<template>
  <div
    :data-qa="dataQa"
    :class="$props.class"
    :style="style"
  >
    <base-label
      v-if="label"
      :for="id"
      :class="$style.label"
    >
      <ui-text
        weight="medium"
        :color="disabled ? 'semilight' : 'main'"
      >
        {{ label }}
      </ui-text>
    </base-label>
    <base-input
      v-bind="$attrs"
      :id="id"
      ref="input"
      :disabled="disabled"
      :class="$style.input"
    />
    <span
      v-if="help"
      :class="$style.help"
      v-html="help"
    />
  </div>
</template>

<script>
import { nanoid } from 'nanoid';
import { UiText } from '@huntflow/ui';
import BaseInput from '@/shared/legacy/ui/input/input.vue';
import BaseLabel from '@/shared/legacy/ui/label/label.vue';

export default {
  name: 'VInput',
  components: {
    BaseLabel,
    BaseInput,
    UiText
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: undefined
    },
    help: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: undefined
    },
    class: {
      type: [String, Array, Object],
      default: undefined
    },
    style: {
      type: [String, Array, Object],
      default: undefined
    }
  },
  data() {
    return {
      id: nanoid()
    };
  },
  methods: {
    setFocus() {
      this.$nextTick(() => {
        this.$refs.input.setFocus();
      });
    }
  }
};
</script>

<style module>
.label {
  display: block;
  margin-bottom: 4px;
  width: max-content;
}

.input + .help {
  margin-top: 4px;
}

.help {
  display: inline-block;
  color: $black;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  opacity: 0.5;
}
</style>

<i18n lang="json">{}</i18n>
